#import "../fragments/ai-feature-usage-fragment.graphql"

query GetAiFeatureUsage($category: AiFeatureCategory!) {
    aiFeatureUsage(category: $category) {
        ...AiFeatureUsageFragment
    }
}
